// import React, { useEffect, useState } from "react";
// import UserAsideNav from "./UserSubComponent/UserAsideNav";
// import { NavLink, Outlet, useNavigate } from "react-router-dom";
// import { IoIosLogOut } from "react-icons/io";
// import { toast } from "react-toastify";
// import "./UserDashboard.css"
// import UserTokenHandler from "../../sharedComponents/UserTokenHandler";
// import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
// import UserNavbar from "./UserNavbar";
// import Navbar from "../../sharedComponents/navbar/Navbar";
// const UserDashboard = () => {

//     const [userId, setUserId] = useState(null);
//     UserTokenHandler();
//     useEffect(() => {
//       setUserId(GetLocalStorageUserId());
//     }, []);

//   const move = useNavigate();
//   const logoutHandle = () => {
//     toast.success("Logout Successfull", {
//       position: "top-right",
//       autoClose: 5000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });
//     localStorage.removeItem("sundorbonBookingUserDetails");
//     localStorage.removeItem("token");
//     move("/");
//   };

//   const handleLoginClick = () => {
//     window.location.href = "https://gotastebkid.azurewebsites.net/Identity/Account/Login";
//   };

//   return (
//     <div className="bg-[#FFFDE7]">

//        {userId ? (
//             <div>
//               <button
//                 onClick={logoutHandle}
//                 className="lg:flex hidden absolute top-3 right-5 items-center gap-2 font-medium lg: mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
//               >
//                 Logout <IoIosLogOut className="text-xl" />
//               </button>
//             </div>
//           ) : (

//             <button
//               className="lg:flex hidden absolute top-3 right-5 z-30 items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
//               onClick={handleLoginClick}
//             >
//               Login
//             </button>
//           )}

//       <div className="min-h-screen lg:pt-6 xl:gap-x-[50px] lg:gap-[20px] flex lg:flex-row flex-col items-start ">
//         <UserAsideNav></UserAsideNav>

//         <div className="w-full relative z-10 lg:w-[75%] xl:w-[80%] pt-8 lg:pt-[100px] lg:px-[0px] min-h-screen">
//           <Outlet></Outlet>{" "}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserDashboard;

import React, { useEffect, useState } from "react";
import UserAsideNav from "./UserSubComponent/UserAsideNav";
import { NavLink, Outlet, useNavigate , useLocation} from "react-router-dom";
import { IoIosLogOut } from "react-icons/io";
import { toast } from "react-toastify";
import "./UserDashboard.css";
import UserTokenHandler from "../../sharedComponents/UserTokenHandler";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { redirectToIdentityLogin } from "../../../utils/identityLogin";

const UserDashboard = () => {
  const [userId, setUserId] = useState(null);
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success("Logout Successfull", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    localStorage.removeItem("sundorbonBookingUserDetails");
    localStorage.removeItem("token");
    move("/");
  };

  const handleLoginClick = () => {
    redirectToIdentityLogin(window.location.origin);
  };

  const routerLocation = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(routerLocation.search);
    const pwdChanged = params.get('pwdChanged');

    if (pwdChanged === 'true') {
      toast.success('Password changed successfully!', {
        position: 'top-right',
        autoClose: 5000,
        theme: 'colored',
      });

      // Clean URL without using global `location`
      window.history.replaceState(
        {},
        '',
        '/user-dashboard'
      );
    }
  }, [routerLocation.search]);

  return (
    <div className="bg-[#FFFDE7]">
      <div className="hidden lg:flex absolute top-3 right-5 gap-4 z-50">
        {/* Booking NavLink */}

        <NavLink
          to="/bookings"
          className="flex items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
        >
          Booking
        </NavLink>

        {/* Conditional render for login/logout */}
        {userId ? (
          <button
            onClick={logoutHandle}
            className="flex items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
          >
            Logout <IoIosLogOut className="text-xl" />
          </button>
        ) : (
          <button
            className="flex items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
            onClick={handleLoginClick}
          >
            Login
          </button>
        )}
      </div>

      <div className="min-h-screen lg:pt-6 xl:gap-x-[50px] lg:gap-[20px] flex lg:flex-row flex-col items-start ">
        <UserAsideNav></UserAsideNav>

        <div className="w-full relative z-10 lg:w-[75%] xl:w-[80%] pt-8 lg:pt-[100px] lg:px-[0px] min-h-screen">
          <Outlet></Outlet>{" "}
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
